import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import {getAppConfigService} from "../services/getAppConfig.service";
import {useAppConfig} from "../store/useAppConfig.store";

/**
 * Custom hook to fetch and use app configuration
 * This hook should be used in the app's root component to fetch the data once
 * Other components should use the store (useAppConfig) directly
 */
const useGetAppConfig = () => {
  const setPMInfo = useAppConfig(state => state.setPMInfo);
  const setBannersCarousel = useAppConfig(state => state.setBannersCarousel);
  const setTabsConfig = useAppConfig(state => state.setTabsConfig);
  const setAuthModalImages = useAppConfig(state => state.setAuthModalImages);
  const setFeatureFlags = useAppConfig(state => state.setFeatureFlags);

  const {data, isLoading, isSuccess, refetch, error} = useQuery({
    queryKey: ["appConfig"],
    queryFn: getAppConfigService,
    staleTime: 1000 * 60 * 30, // 30 minutes
    gcTime: 1000 * 60 * 60, // 1 hour
    refetchOnMount: false,
    refetchOnWindowFocus: false, // Prevent refetching when window gains focus
  });

  useEffect(() => {
    if (error) {
    }
  }, [error]);

  useEffect(() => {
    if (data) {
      setPMInfo(
        data?.data.data.business_info.BankName,
        data.data.data.business_info.RIF,
        data.data.data.business_info.PMNumber
      );
      setBannersCarousel(data?.data.data.carrousels);
      setTabsConfig(data?.data.data.tab_configs);
      // Set auth modal images from config
      setAuthModalImages(data?.data.data.auth_modal_images);
      // Set feature flags from config
      setFeatureFlags(data?.data.data.feature_flags);
    }
  }, [data, setPMInfo, setBannersCarousel, setTabsConfig, setAuthModalImages, setFeatureFlags]);

  return {
    data,
    isLoading,
    isSuccess,
    refetch,
  };
};

export default useGetAppConfig;
